// extracted by mini-css-extract-plugin
export default {"circle":"styles_circle__aIQpK","chip":"styles_chip__FbPkp"};